module.exports = __webpack_public_path__ + "static/img/5.3fa6d1b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/zh/5.png
// module id = rApT
// module chunks = 0